import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';

import { formatDate } from '../utils';
import { numberFormat } from '~/core/scripts/utils';

class BulletPoints extends PureComponent {
  render() {
    const { minDate, maxDate, cases = 0 } = this.props;
    const startDate = (minDate && formatDate(minDate)) || '';
    const endDate = (maxDate && formatDate(maxDate)) || '';
    const casesFormatted = numberFormat(cases);

    return ReactDOM.createPortal(
      <p className="bulletpoint__text">
        Aktuelle Saison: Vom <strong>{startDate}</strong> (40.KW) bis zum <strong> 
        <span style={{display:'none'}}>{endDate}</span>  
       22.5.2022 </strong> (20.KW).<br />
        <span style={{display:'none'}}>
          Bisher wurden <strong className="highlight">{casesFormatted} bestätigte Fälle</strong> gemeldet.
        </span>
      </p>,
      document.getElementById('bulletpoints')
    );
  }
}

export default BulletPoints;
